import { observable, action, computed, toJS } from 'mobx';
import * as dashboardService from '../services/dashboardService';
const { Account, Tracker } = window.$ACE;



//去重
function unique(arr) {
  let newArr = [];
  for (let i = 0; i < arr.length; i++) {
    if (newArr.indexOf(arr[i]) == -1) {
      newArr.push(arr[i]);
    }
  }
  return newArr;
}
//移除数组某一项
function remove(arr, val) {
  let index = arr.indexOf(val);
  if (index > -1) {
    arr.splice(index, 1);
  }
}



class DashboardStore {
  constructor() {
  }
  @observable dialogContent = '';
  @observable price = [0, 0, 0, 0, 0, 0, 0, 0];//用来计算总价的数组
  @observable cardStatus = [0, 0, 0, 0, 0, 0, 0, 0];//用来控制卡片选中状态的数组
  @observable productCodeList = [];
  @observable productCodeListLength = 0;
  @observable loading = false;
  @observable cartIndex = []
  @observable isLogin = false
  init = async () => {
    await this.fetchLoginState();
  };
  //判断是否登陆
  @action
  fetchLoginState = async () => {
    const isLogin = await Account.isLogin();
    this.isLogin = isLogin;
  };
  //跳转登陆页面
  @action
  handleNotLogin = () => {
    const loginUrl = 'https://account.aliyun.com/login/login.htm?oauth_callback=';
    const callBackUrl = encodeURIComponent(window.location.href);
    const redirectUrl = Tracker.addSpm(loginUrl + callBackUrl, 'body');
    return (window.location.href = redirectUrl);
  };

  @action async fetchDialogData() {
    try {
      let response = await dashboardService.fetchDialogData();
      this.dialogContent = response;
    } catch (e) {
      throw e;
    }
  }
  @action chooseCard(status) {
    if (this.cardStatus[status]) {
      this.cardStatus[status] = 0;
    } else {
      this.cardStatus[status] = 1;
    }
  }

  @action chooseCardPopUpConfig(status) { //选择详细配置后就会选中
    this.cardStatus[status] = 1;
  }

  //改变总价
  @action changeTotalPrice(index, price) {
    this.price = this.price.map((item, idx) => {
      if (idx == index) {
        return price;
      } else {
        return item;
      }
    });
  }
  //添加商品
  @action addProduct(productCode) {
    //console.log(productCode, 'productCode');
    this.productCodeList.push(productCode);
    this.productCodeListLength = unique(toJS(this.productCodeList)).length;
  }
  //移除商品
  @action removeProduct(productCode, index) {
    remove(this.productCodeList, productCode);
    remove(this.cartIndex, index);
    this.productCodeListLength = unique(toJS(this.productCodeList)).length;
  }

  @action changeLoading(flag) {
    this.loading = flag;
  }

  //要批量加入购物车的产品
  @action addCart(status) {
    this.cartIndex.push(status);
  }

  //去除要加入购物车的产品
  @action removeCart(status) {
    remove(this.cartIndex, status);
  }

  //加入购物车清空选中状态
  @action clearCart() {
    this.cardStatus = [0, 0, 0, 0, 0, 0, 0, 0];//选中回到初始状态
    this.price = [0, 0, 0, 0, 0, 0, 0, 0]; //金额回到初始状态
    this.productCodeList = []; //选择的产品总数回到初始状态
    this.productCodeListLength = 0; //满减规则回到0的初始状态   
    this.cartIndex = []; //购物车回到初始状态
  }

  //获得的总价
  @computed get totalPrice() {
    let sum = 0;
    this.price.filter((item, idx) => {
      return this.cardStatus[idx] == 1;
    }).forEach(item => {
      //console.log(item,"item");
      
      sum += item;
    });
    return sum;
  }
  //获得的总的产品个数
  @computed get totalProduct() {
    let totalLength = unique(toJS(this.productCodeList));
    return totalLength.length;
  }
}
let dashboardStore = new DashboardStore();
export default dashboardStore;


// WEBPACK FOOTER //
// ./src/scripts/stores/DashboardStore.js